module.exports = __webpack_public_path__ + "static/media/paraco_karin.99f01f4f.png";